import React, { useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import { Modal, Button } from "react-bootstrap";

import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { Alert, Snackbar } from "@mui/material";
import uploadAndDownloadService from "../../../services/uploadAndDownloadFile";
import { useNavigate } from "react-router-dom";
import UploadChargeFileDownloaded from "./UploadChargeFileDownloaded";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import ChargeService from "../../../services/ChargesPayement/ChargeService";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
const DataChargeList = ({ listTransaction, allMagasin }) => {
  const [infoAlertText, setInfoAlertText] = useState();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const navigate = useNavigate();
  const [chargeUrlFileDownload, setChargeUrlFileDownload] = useState();
  const [onUploadFile, setOnUploadFile] = useState(false);
  const [showAddShop, setShowAddShop] = useState(false); // Modal visibility
  const animatedComponents = makeAnimated();
  const [magasinSelectedOption, setMagasinSelectedOption] = useState(null);
  const [magasinId, setMagasinId] = useState(0);
  const [magasinSelectPlaceHolder, setMagasinSelectPlaceHolder] =
    useState("aucun");
  const [selectedOption, setSelectedOption] = useState(null);
  const handleShow = () => setShowAddShop(true);
  const [selectedRow, setSelectedRow] = useState(null);

  const onChangeSelectedMagasin = (selectedOptionn) => {
    setSelectedOption("");
    setMagasinId(selectedOptionn.value);
    setMagasinSelectedOption(selectedOptionn.label);
    setMagasinSelectPlaceHolder(selectedOptionn.label);
  };
  const { SearchBar } = Search;
  const MyExportCSV = (props) => {
    const handleClick = () => {
      props.onExport();
    };
    return (
      <div>
        <button className="btn btn-dark" onClick={handleClick}>
          <i class="fas fa-download"></i> Télécharger CSV
        </button>
      </div>
    );
  };
  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };
  function handleTableChange({ products }) {
    return products;
  }
  const onShowFileInOtherWizndowHandler = (path) => {
    uploadAndDownloadService
      .downloadFile(path)
      .then((response) => {
        //Build a URL from the file
        if (response.headers["content-type"] === "image/png") {
          const file = new Blob([response.data], { type: "image/png" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "application/pdf") {
          const file = new Blob([response.data], { type: "application/pdf" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "image/jpeg") {
          const file = new Blob([response.data], { type: "image/jpeg" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "image/jpg") {
          const file = new Blob([response.data], { type: "image/jpg" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        }
      })
      .catch(() => {
        // setOpenErrorAlert(true);
        // setErrorAlertText("Erreur : il ya un probléme de connexion");
      });
  };

  const onUploadFileHandler = (idCharge) => {
    setChargeUrlFileDownload({
      idCharge: idCharge,
    });
    setOnUploadFile(true);
  };
  function filePayementFormatter(cell, row) {
    if (row.urlFileDownload === "none") {
      return (
        <button
          style={{ width: 40 }}
          class="btn bg-gray btn-sm "
          onClick={() => onUploadFileHandler(row.id)}
        >
          <i class="fas fa-plus"></i>
        </button>
      );
    } else {
      return (
        <button
          style={{ width: 40 }}
          class="btn bg-gray btn-sm "
          onClick={() => onShowFileInOtherWizndowHandler(row.urlFileDownload)}
        >
          <i class="fas fa-eye"></i>
        </button>
      );
    }
  }
  function shopFormatterFormatter(cell, row) {
    if (row.shop !== null && row.shop !== undefined) {
      return <p>{row.shop?.name}</p>;
    } else {
      return <p>Aucun magasin </p>;
    }
  }
  const addPayementHandler = (id) => {
    localStorage.setItem("chargeId", id);
    navigate(`/payerCharges`);
  };

  function buttonPayementFormatter(cell, row) {
    if (row.payed === 0) {
      return (
        <button
          class="btn bg-primary btn-sm "
          onClick={() => addPayementHandler(row.id)}
        >
          Payer
        </button>
      );
    } else if (row.payed === 1) {
      return (
        <button
          className="btn bg-success  btn-sm "
          onClick={() => addPayementHandler(row.id)}
        >
          Payée
        </button>
      );
    }
  }
  function attachStoreFormatter(cell, row) {
    return (
      <button
        style={{ width: 40 }}
        className="btn bg-black btn-sm"
        onClick={() => {
          // Your click handling logic here
          setSelectedRow(row);
          console.log(row);
          handleShow();
        }}
      >
        <i className="fas fa-edit"></i> {/* Changed icon to 'fa-edit' */}
      </button>
    );
  }

  const columns = [
    {
      dataField: "ref",
      text: "Reférence",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "20%" };
      },
    },
    {
      dataField: "title",
      text: "Titre ",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "20%" };
      },
    },
    {
      dataField: "month",
      text: "Mois ",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "20%" };
      },
    },
    {
      dataField: "year",
      text: "Année ",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "20%" };
      },
    },
    {
      dataField: "id",
      text: "Magasin",
      align: "center",
      headerAlign: "center",
      formatter: shopFormatterFormatter,

      headerStyle: () => {
        return { width: "20%" };
      },
    },
    {
      dataField: "price",
      text: "Prix",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "20%" };
      },
    },
    {
      dataField: "id",
      text: "Fichier",
      formatter: filePayementFormatter,
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "15%" };
      },
    },
    {
      dataField: "id",
      text: "Modifier Magasin",
      formatter: attachStoreFormatter,
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "15%" };
      },
    },
    {
      dataField: "id",
      text: "Payer",
      formatter: buttonPayementFormatter,
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "15%" };
      },
    },
  ];
  const pageButtonRenderer = ({
    page,
    active,
    disable,
    title,
    onPageChange,
  }) => {
    const handleClick = (e) => {
      e.preventDefault();
      onPageChange(page);
    };
    const activeStyle = {};
    if (active) {
      activeStyle.backgroundColor = "black";
      activeStyle.color = "white";
    } else {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    if (typeof page === "string") {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    return (
      <li className="page-item">
        <button
          className="btn btn-dark"
          onClick={handleClick}
          style={activeStyle}
        >
          {page}
        </button>
      </li>
    );
  };
  const options = {
    pageButtonRenderer,
  };
  const listRates = (list) => {
    return (
      <table
        class="table table-striped table-bordered table-sm"
        cellspacing="0"
        width="100%"
      >
        <thead>
          <tr className="text-center">
            <th style={{ width: "40%" }}>Libellé</th>
            <th style={{ width: "30%" }}>Valeur</th>
          </tr>
        </thead>
        <tbody>
          {list &&
            list.map((element, i) => (
              <tr className="text-center" key={i}>
                <td>
                  {element.rate?.code}-{element.rate?.name}
                </td>
                <td>{element.price} </td>
              </tr>
            ))}
        </tbody>
      </table>
    );
  };
  const expandRow = {
    renderer: (row) => listRates(row.chargeValues),
    showExpandColumn: true,
    expandHeaderColumnRenderer: ({ isAnyExpands }) => {
      if (isAnyExpands) {
        return <b style={{ cursor: "pointer" }}>-</b>;
      }
      return <b style={{ cursor: "pointer" }}>+</b>;
    },
    expandColumnRenderer: ({ expanded }) => {
      if (expanded) {
        return <b style={{ cursor: "pointer" }}>-</b>;
      }
      return <b style={{ cursor: "pointer" }}>+</b>;
    },
  };

  const handleCloseShop = () => {
    setShowAddShop(false);
  };

  const handleAddShop = () => {
    // Validate inputs

    ChargeService.attachedStore(getCurrentUserId(), selectedRow.id, magasinId)
      .then((response) => {
        console.log(response);

        handleCloseShop();
        window.location.reload();
      })
      .catch((error) => {
        console.error("Error updating quantity:", error);
      });
  };

  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">Les charges </h3>
      </div>
      <div className="card-body">
        <ToolkitProvider
          keyField="id"
          data={listTransaction}
          columns={columns}
          onTableChange={handleTableChange}
          exportCSV
          search
        >
          {(props) => (
            <div>
              <div className="row ml-0">
                <div>
                  <SearchBar
                    {...props.searchProps}
                    className="custome-search-field"
                    style={{ color: "black" }}
                    placeholder="Chercher"
                  ></SearchBar>
                </div>
                <div className="ml-auto mr-0">
                  <MyExportCSV {...props.csvProps}></MyExportCSV>
                </div>
              </div>
              <div className="row">
                <BootstrapTable
                  {...props.baseProps}
                  pagination={paginationFactory(options)}
                  striped
                  hover
                  condensed
                  expandRow={expandRow}
                />
              </div>
            </div>
          )}
        </ToolkitProvider>
      </div>

      <Modal show={showAddShop} onHide={handleCloseShop} centered>
        <Modal.Header>
          <Modal.Title>Modifier le magasin</Modal.Title>
          <button className="close" onClick={handleCloseShop}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="col-sm-12">
            <div className="form-group">
              <label htmlFor="inputClientCompany">Choisir le magasin</label>
              <Select
                closeMenuOnSelect={true}
                components={animatedComponents}
                defaultValue={magasinSelectedOption}
                onChange={onChangeSelectedMagasin}
                options={allMagasin}
                placeholder={magasinSelectPlaceHolder}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="success" onClick={handleAddShop}>
            Ajouter
          </Button>
        </Modal.Footer>
      </Modal>

      {onUploadFile && (
        <UploadChargeFileDownloaded
          setOnUploadFile={setOnUploadFile}
          chargeUrlFileDownload={chargeUrlFileDownload}
        />
      )}

      {openInfoAlert && (
        <Snackbar
          open={openInfoAlert}
          autoHideDuration={2000}
          onClose={handleInfoClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          <Alert variant="filled" onClose={handleInfoClose} severity="info">
            {infoAlertText}
          </Alert>
        </Snackbar>
      )}
    </div>
  );
};
export default DataChargeList;
